import React from 'react';
import ReactDOM from 'react-dom';

import { WebPosApp } from 'webPosApp';
import { KioskApp } from 'kioskApp';
import 'shared/assets/styles/index.scss';
import 'react-simple-keyboard/build/css/index.css';
import * as serviceWorker from 'serviceWorker';
import { QueryParams, extractUrlParam, PlatformNames } from 'shared/helpers';

(async function main() {
    try {
        const posPlatform = extractUrlParam(
            QueryParams.PosPlatform,
            window.location.href
        );

        if (
            posPlatform === PlatformNames.Ehopper ||
            posPlatform === PlatformNames.WebPos
        ) {
            ReactDOM.render(<WebPosApp />, document.getElementById('root'));
        } else {
            ReactDOM.render(<KioskApp />, document.getElementById('root'));
        }

        serviceWorker.unregister();
    } catch (error) {
        console.log('main function was fallen', error);
    }
})();
